import api from "@/api";
import { getCurrentInfo, getLocalStorage, getParameter, getQueryVariable, removeLocalStorage, setLocalStorage } from "@/utilities/common";
import { getBasePath, getDefaultRouter } from "@/utilities/function";
import { clearAllCookie } from "@/utilities/storage";
import { observer } from "@/utilities/storeHook";
import { isLeadGenAgency } from "@LeadGen/utilities/function";
import { ReactElement, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
interface Props {
  children: ReactElement;
}
const ignoreUrlList = ["/", "", "/invitation", "/redirect", "/empty"];
const PrivateRoute = ({ children }: Props) => {
  const location = useLocation();
  const { pathname, search } = location;
  const navigate = useNavigate();

  // 动态获取认证状态和用户信息，而不是使用静态的 useState
  const isAuthenticated = getLocalStorage("isAuthenticated") === "true";
  const userInfo = getLocalStorage("userInfo");
  const invitationPathName = getLocalStorage("invitationPathName") || "";
  const loginOption = getQueryVariable("loginOption") || "";
  const CID = getParameter("cid");
  const isCN = getCurrentInfo("region")?.toLowerCase() === "zh-cn";

  useEffect(() => {
    try {
      if (getLocalStorage("userInfo") === null) {
        pathname !== "/invitation" && navigate("/");
      }
      if (isAuthenticated) {
        if (getLocalStorage("userInfo") && getLocalStorage("invitationPathName")) {
          const invitationPath: string = getLocalStorage("invitationPathName") || "";
          if (location.pathname === "/") {
            removeLocalStorage("invitationPathName");
            navigate(location.pathname);
          } else {
            navigate(invitationPath);
          }
        } else {
          if (location.pathname !== "/" && location.pathname !== "/login" && location.pathname !== "/redirect") {
            navigate(`${location.pathname}${search}`);
          } else {
            removeLocalStorage("changeAccount");
            if (getLocalStorage("userInfo")) {
              const CID_data = {
                msaId: JSON.parse(getLocalStorage("userInfo") || "{}")?.id,
                email: JSON.parse(getLocalStorage("userInfo") || "{}")?.accountUsername
              };
              const source: any = getQueryVariable("state");
              if (source && source?.indexOf("register_ms_email") !== -1) {
                setLocalStorage("loginOption", JSON.stringify({
                  signUp: true,
                  signIn: false
                }));
              }
              // setLocalStorage("token", JSON.parse(getLocalStorage("userInfo") || "{}").token);
              if (getLocalStorage("invitationPathName")) {
                const invitationPath: string = getLocalStorage("invitationPathName") || "";
                navigate(invitationPath);
              } else {
                api.getUserInfo().then((res: any) => {
                  api.Customer.CIDlist(CID_data).then((res: any) => {
                    if (res !== undefined) {
                      setLocalStorage("customers", res);
                      if (getLocalStorage("loginOption")) {
                        if (JSON.parse(getLocalStorage("loginOption") || "").signIn) {
                          if (res.customers && res.customers.length > 1) {
                            if (res.customers.filter((val: any) => val.customerStatus === 1).length > 0) {
                              if (res.defaultCustomerId) {
                                api.Customer.customerSelect({ cid: res.defaultCustomerId }).then((res: any) => {
                                  if (["/dashboard", "/Non_dashboard", "/", "/login", "/redirect"].includes(pathname)) {
                                    const url = getDefaultRouter(res?.customerType,
                                      !isLeadGenAgency(res?.agencyType)
                                        ? "waitingOrder"
                                        : "leadgen_accountManagement", `?cid=${res.customerId}`,
                                        res?.region?.toLowerCase() === "zh-cn" ? "dashboard" : "Non_dashboard");
                                    navigate(url);
                                  } else {
                                    navigate(`${location.pathname}${search}`);
                                  }
                                });
                              } else {
                                navigate(!ignoreUrlList.includes(location.pathname) ? `${location.pathname}${search}` : "/customer");
                              }
                            } else {
                              navigate(!ignoreUrlList.includes(location.pathname) ? `${location.pathname}${search}` : "/customer");
                            }
                          } else if (res.customers && res.customers.length === 1) {
                            if (res.customers[0].customerStatus === 0) {
                              setLocalStorage("createdCustomer", JSON.stringify(res.customers[0]));
                              navigate("/giveCIDAndUID");
                            } else if (res.customers[0].numberOfAccounts === 0) {
                              setLocalStorage("currentCID", res.customers[0].customerId);
                              api.Customer.customerSelect({ cid: res.customers[0].customerId }).then((res: any) => {
                                if (res?.accounts && res?.accounts.length > 0) {
                                  const url = getDefaultRouter(res?.customerType,
                                    !isLeadGenAgency(res?.agencyType)
                                      ? "waitingOrder"
                                      : "leadgen_accountManagement", "",
                                    isCN ? "dashboard" : "Non_dashboard");
                                  const newBasePath = getBasePath(Number(res?.productType), Number(res?.primaryPurpose), "/leage_createAccount", url);
                                  navigate(`${location.pathname}${location.pathname === "/"
                                    ? newBasePath.slice(1)
                                    : ""}?cid=${res.customerId}`);
                                } else {
                                  if (!CID) {
                                    const newBasePath = getBasePath(Number(res.productType), Number(res.primaryPurpose), "/leadgen_createAccount", "/createAccount");
                                    navigate(newBasePath);
                                  }
                                }
                              });
                            } else {
                              api.Customer.customerSelect({ cid: res.customers[0].customerId }).then((res: any) => {
                                if (res) {
                                  const url = getDefaultRouter(res?.customerType,
                                    !isLeadGenAgency(res?.agencyType) ? "waitingOrder" : "leadgen_accountManagement",
                                    "",
                                    isCN ? "dashboard" : "Non_dashboard");
                                  const newBasePath = getBasePath(Number(res?.productType), Number(res?.primaryPurpose), "/leadgen_accountManagement", url);
                                  navigate(`${newBasePath}?cid=${res.customerId}`);
                                  /* navigate(`${location.pathname}${location.pathname === "/"
                                    ? newBasePath.slice(1)
                                    : ""}?cid=${res.customerId}`); */

                                  // navigate(`${location.pathname}${location.pathname === "/"
                                  //   ? res.customerType === CustomerAgencyType.BillingAgency
                                  //     ? "waitingOrder"
                                  //     : "Dashboard"
                                  //   : ""}?cid=${res.customerId}`);
                                } else {
                                  navigate(!ignoreUrlList.includes(location.pathname) ? `${location.pathname}${search}` : "/customer");
                                }
                              });
                            }
                          } else {
                            if (res.customers && res.customers.length < 1) {
                              navigate("/login_signUp");
                            }
                          }
                        } else {
                          if (res.customers.length > 0) {
                            navigate("/signUp_or_login");
                          } else {
                            navigate("/chooseMarket");
                            // navigate("/Registration");
                          }
                        }
                      } else {
                        pathname !== "/invitation" && navigate("/");
                      }
                    }
                  });
                });
              }
            }
          }
        }
      }
    } catch (error) {
      clearAllCookie();
      sessionStorage.clear();
      localStorage.clear();
      pathname !== "/invitation" && navigate("/");
    }
  }, [isAuthenticated, userInfo, invitationPathName, loginOption]);
  return <>{children}</>;
};
export default observer(PrivateRoute);
